import i18next from "../../utils/i18n"

function ImageSlider() {
  let slide1;
  let slide2;
  let slide3;

  if (i18next.language === "de") {
    slide1 = "/images/Titelbild_white_A.jpg"
    slide2 = "/images/Titelbild_white_B.jpg"
    slide3 = "/images/Titelbild_white_C.jpg"
  } else {
    slide1 = "/images/en/Titelbild_white_A.jpg"
    slide2 = "/images/en/Titelbild_white_B.jpg"
    slide3 = "/images/en/Titelbild_white_C.jpg"
  }

  return <div>
    <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
      <ol className="carousel-indicators">
        <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
      </ol>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img className="d-block w-100" src={slide1} alt="First slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={slide2} alt="Second slide" />
        </div>
        <div className="carousel-item">
          <img className="d-block w-100" src={slide3} alt="Third slide" />
        </div>
      </div>
      <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
        <span className="" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
        <span className="" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  </div>
}
export default ImageSlider;
